import { useEffect } from "react";

// Written only after the account's connection swap and guest replay have settled.
// Listening to the credential write itself would open actor.db halfway through a reset.
const ACCOUNT_READY_KEY = "han:account-ready";
const ACCOUNT_PUBLISHED_EVENT = "han-account-published";

export function publishAccountChange(): void {
  if (globalThis.window !== undefined) {
    globalThis.localStorage.setItem(ACCOUNT_READY_KEY, crypto.randomUUID());
    globalThis.dispatchEvent(new Event(ACCOUNT_PUBLISHED_EVENT));
  }
}

export function useCrossTabAccountChanges(): void {
  useEffect(() => {
    let observed = globalThis.localStorage.getItem(ACCOUNT_READY_KEY);
    const refresh = () => {
      const current = globalThis.localStorage.getItem(ACCOUNT_READY_KEY);
      if (current !== observed) {
        observed = current;
        // A document reload closes the old worker, clears account-scoped React
        // Query/auth caches, and reopens the persisted account through its leader.
        globalThis.location.reload();
      }
    };
    const onStorage = (event: StorageEvent) => {
      if (event.storageArea === globalThis.localStorage && event.key === ACCOUNT_READY_KEY) {
        refresh();
      }
    };
    const onPublished = () => {
      observed = globalThis.localStorage.getItem(ACCOUNT_READY_KEY);
    };
    globalThis.addEventListener(ACCOUNT_PUBLISHED_EVENT, onPublished);
    globalThis.addEventListener("storage", onStorage);
    // A discarded/backgrounded page may miss the event, but not the durable marker.
    window.addEventListener("pageshow", refresh);
    window.addEventListener("focus", refresh);
    return () => {
      globalThis.removeEventListener("storage", onStorage);
      globalThis.removeEventListener(ACCOUNT_PUBLISHED_EVENT, onPublished);
      window.removeEventListener("pageshow", refresh);
      window.removeEventListener("focus", refresh);
    };
  }, []);
}
